"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var UrlService = /** @class */ (function () {
    function UrlService() {
    }
    /**
     * Returns an object representation of the query params of a url
     * Example: https://mysite.com?myVar=Hello&myOtherVar=5000 -> { myVar: 'Hello', myOtherVar: '5000' }
     * @param url
     */
    UrlService.prototype.getUrlParametersAsObject = function (url) {
        var queryParamSplit = url.split('?');
        if (queryParamSplit.length === 1) {
            return {};
        }
        try {
            return JSON.parse('{"' + decodeURI(queryParamSplit[1].replace(/&/g, '","').replace(/=/g, '":"')) + '"}');
        }
        catch (ex) {
            console.warn('Failed to parse query string. Please ensure that query param values and keys are properly URI encoded', ex, queryParamSplit[1]);
            return {};
        }
    };
    /**
     * Returns a string representation of the query params object
     * Example: { a: 1, b: undefined, c: 3 } -> 'a=1&c=3'
     * @param params
     */
    UrlService.prototype.getURLParametersAsString = function (params) {
        return new URLSearchParams(Object.entries(params).filter(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            // Filter undefined, null, and ''.
            var isFilteredValue = value === undefined || value === null || value === '';
            return key && !isFilteredValue;
        })).toString();
    };
    /**
     * Returns a string of the url with the correct protocol and no trailing slash
     * Example: www.example.com/ -> https://www.example.com
     * @param domain
     */
    UrlService.prototype.normalizeDomain = function (domain) {
        if (!domain) {
            return '';
        }
        if (!domain.startsWith('https://') && !domain.startsWith('http://')) {
            domain = 'https://' + domain;
        }
        if (domain.endsWith('/')) {
            domain = domain.substr(0, domain.length - 1);
        }
        return domain;
    };
    UrlService = __decorate([
        CommonService_decorator_1.CommonService('UrlService')
    ], UrlService);
    return UrlService;
}());
exports.UrlService = UrlService;
//# sourceMappingURL=Url.service.js.map